import { TemperatureApiModel, TemperatureResultApiModel } from '@rocksoft/inroom-sdk';

import { Action } from '@ngrx/store';

import { TemperatureChangedEvent } from '../../../../shared/events/temperature-changed.event';

export enum TemperatureActionTypes {
  LOAD_TEMPERATURE = '[Temperature] Load Temperature',
  NO_TEMPERATURE = '[Temperature] No Temperature',
  UPDATE_TEMPERATURE = '[Temperature] Update Temperature',
}

export interface TemperatureLocationModel extends TemperatureResultApiModel {
  HotelCode?: string;
  Room?: string;
}

export class LoadTemperature implements Action {
  readonly type = TemperatureActionTypes.LOAD_TEMPERATURE;

  constructor(public payload: TemperatureApiModel) {}
}

export class NoTemperature implements Action {
  readonly type = TemperatureActionTypes.NO_TEMPERATURE;
}

export class UpdateTemperature implements Action {
  readonly type = TemperatureActionTypes.UPDATE_TEMPERATURE;

  constructor(public payload: { id: string; changes: TemperatureChangedEvent }) {}
}

export type TemperatureActionsUnion = LoadTemperature | NoTemperature | UpdateTemperature;
